














































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxAutocomplete, DxRadioGroup, DxLookup } from 'devextreme-vue';
import Card from '@/components/default/Card.vue';
import notificationService from '@/services/notificationService';
import MailDialog from '@/modules/invoicing/components/MailPopup.vue';
import PdfViewer from '@/plugins/pdfjs/PdfViewer.vue';

import { DxForm, DxSimpleItem, DxLabel, DxItem } from 'devextreme-vue/form';

import {
  InvoiceDto,
  InvoicesClient,
  GenerateInvoiceDocumentCommand,
  InvoiceDocumentSettings,
  ProgressStatementExportType,
  ProgressStatementListItemDto,
  ProgressStatementsClient,
  GetProgressStatementsForInvoiceQuery,
  ProgressStatement,
} from '@/data/web-api-client';
import moment from 'moment';

@Component({
  components: {
    Card,
    DxForm,
    DxSimpleItem,
    DxLabel,
    DxAutocomplete,
    MailDialog,
    PdfViewer,
    DxRadioGroup,
    DxLookup,
    DxItem,
  },
})
export default class InvoiceDocument extends Vue {
  @Prop({ required: true })
  invoice!: InvoiceDto;
  pdfSize: number = 450;
  settings: InvoiceDocumentSettings = new InvoiceDocumentSettings({
    hideUnitPrices: false,
    hideLineTotals: false,
    hideLineAmounts: false,
    hideSubtotals: false,
    hideTotals: false,
    hideSubtotalDetails: false,
    groupArticlesByCategory: false,
    summarizeByProgressStatement: false,
    progressStatementMergedDocumentNumber: undefined,
  });
  document: {
    loading: boolean;
    initialised: boolean;
    url: string;
  } = {
    loading: false,
    initialised: false,
    url: '',
  };
  selectedExportType = ProgressStatementExportType.None;
  // progressStatementForm: {
  //   progressStatement: any | undefined;
  // } = {
  //   progressStatement: undefined,
  // };
  languages: any[] = [];

  progressStatements: ProgressStatementListItemDto[] = [];

  mounted() {
    this.loadProgressStatements().then(() => {
      this.pdfSize = window.innerHeight - 275;
      if (this.invoice.documentSettings && this.invoice.documentSettings !== null) {
        Object.assign(this.settings, this.invoice.documentSettings);
      }
      this.languages = this.$store.getters['catalogs/list']('Languages')?.values ?? [];
      this.loadDocument();
    });
  }

  async loadDocument() {
    try {
      this.document.loading = true;
      const result = await new InvoicesClient(undefined, this.$axios).getDocument(this.$route.params.id);

      this.document.url = window.URL.createObjectURL(result.data);
      this.document.initialised = true;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.document.loading = false;
    }
  }

  async generateDocument() {
    try {
      this.document.loading = true;
      const result = await new InvoicesClient(undefined, this.$axios).generateDocument(
        this.invoice.id!,
        new GenerateInvoiceDocumentCommand({
          id: this.$route.params.id,
          documentSettings: new InvoiceDocumentSettings(this.settings),
        })
      );

      this.document.url = window.URL.createObjectURL(result.data);
      this.document.initialised = true;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.document.loading = false;
    }
  }

  openMailDialog() {
    (this.$refs.MailDialog as MailDialog).open();
  }

  async loadProgressStatements() {
    if (!this.invoice?.projectId) {
      return;
    }

    const query = new GetProgressStatementsForInvoiceQuery({
      projectId: this.invoice.projectId,
    });
    const result = await new ProgressStatementsClient(undefined, this.$axios).getForInvoice(query);

    if (result.length == 0) {
      this.selectedExportType = ProgressStatementExportType.None;
    }
    this.progressStatements = result;
  }

  mailSend() {
    this.$emit('mailSend');
  }

  get exportOptions() {
    return [
      {
        id: ProgressStatementExportType.None,
        title: 'Niet meesturen',
      },
      {
        id: ProgressStatementExportType.Standard,
        title: 'Standaard vorderstaat',
      },
      {
        id: ProgressStatementExportType.Pdf,
        title: 'Uitgebreide vorderstaat',
      },
    ];
  }

  get progressStatementOptions() {
    const result = this.progressStatements.map((ps) => ({
      id: `${ps.documentNumber!}-${ps.versionNumber!}`,
      value: `${ps.documentNumber!}-${ps.versionNumber!} (${moment(ps.date).format('DD/MM/yyyy')})`,
      documentNumber: `${ps.documentNumber!}-${ps.versionNumber!}`,
    }));

    return {
      dataSource: result,
      displayExpr: 'value',
      filterExpr: 'id',
      valueExpr: (ps: ProgressStatement) => {
        return ps.documentNumber;
      },
    };
  }

  get languageOptions() {
    const items = this.languages.map((l) => ({
      value: l,
      text: l,
    }));

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
      showClearButton: 'true',
      value: this.settings?.language,
    };
  }
}
